module.exports = __webpack_public_path__ + "media/images/pc/page_common/logo/logo_footer_eight-0650338b801f3abf2958b1dd58529afb.svg";